module.exports = __webpack_public_path__ + "static/img/GYWM-19.c09e3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-19.jpg
// module id = nhKq
// module chunks = 1